import React, { useState } from "react";

const OFFICIAL_BUTTONS = {
  google: {
    src: "/identity/google-sign-in.png",
    source: "google-identity-local",
  },
  apple: {
    src: "https://appleid.cdn-apple.com/appleid/button?height=41&color=black&border_radius=0&type=continue&locale=en_US",
    source: "appleid-cdn",
  },
  microsoft: {
    src: "/identity/microsoft-sign-in.svg",
    source: "microsoft-identity-local",
  },
};

export default function ProviderButton({ provider, label, href }) {
  const [imageFailed, setImageFailed] = useState(false);
  const asset = OFFICIAL_BUTTONS[provider];
  if (!asset) return null;
  return (
    <a
      className={`provider-${provider} flex w-full items-center justify-center`}
      href={href}
      aria-label={label}
      data-testid={`provider-${provider}`}
      data-brand-source={asset.source}
    >
      {imageFailed ? (
        <span className="inline-flex h-[41px] items-center rounded border border-gray-400 bg-white px-6 text-sm font-medium text-gray-800">
          {label}
        </span>
      ) : (
        <img
          className="h-[41px] w-auto max-w-full"
          src={asset.src}
          alt={label}
          onError={() => setImageFailed(true)}
        />
      )}
    </a>
  );
}
